import { CatInlineNotification } from '@blocks-react/components/InlineNotification';
import { CatIconWarningCircle } from '@blocks-react/components/Icons/WarningCircle';
import { CatIconSuccess } from '@blocks-react/components/Icons/Success';
import { Conditional } from '@cat-ecom/pcc-components';
import { SUCCESS } from '../constant';

interface SystemFeedbackBannerProps {
  heading: string;
  variant: 'success' | 'warning' | 'error';
  description?: string;
  dismissible?: boolean;
  close?: () => void;
  classname?: string;
}

const RequestEquipmentServiceFeedbackBanner = ({
  heading,
  variant,
  description,
  dismissible = false,
  close,
  classname
}: Readonly<SystemFeedbackBannerProps>) => {
  const isSuccessBanner = variant === SUCCESS;
  return (
    <div className={classname}>
      <CatInlineNotification
        heading={heading}
        variant={variant}
        dismissible={dismissible}
        onBlInlineNotificationClose={close}
      >
        <Conditional
          test={isSuccessBanner}
          fallback={<CatIconWarningCircle slot="before" />}
        >
          <CatIconSuccess slot="before" />
        </Conditional>
        <span className="u-color--ExtraDarkGray">{description ?? null}</span>
      </CatInlineNotification>
    </div>
  );
};

export default RequestEquipmentServiceFeedbackBanner;
